import { useState, useCallback } from "react";
import {
  Box,
  Typography,
  LinearProgress,
  IconButton,
  Chip,
  Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import UploadFileIcon from "../../../../assets/UploadFileIcon.svg";

import { t } from "i18next";
import UploadDocumentButton from "../../../../components/common/UploadDocumentButton";

export default function FileUpload(props: any) {
  const { uploadDocument, loanDetails } = props;

  const [files, setFiles] = useState<any[]>([]);
  const [dragging, setDragging] = useState(false);

  const handleDrop = useCallback((e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setDragging(false);
    addFiles(e.dataTransfer.files);
  }, []);

  const addFiles = (newFiles: any) => {
    const toAdd = Array.from(newFiles);
    setFiles((prev: any) => [...prev, ...toAdd]);
    // simulate upload progress per file...
    if (uploadDocument) {
      uploadDocument(toAdd);
    }
  };

  return (
    <Box
      onDragOver={(e) => {
        e.preventDefault();
        setDragging(true);
      }}
      onDragLeave={() => setDragging(false)}
      onDrop={handleDrop}
      sx={{
        border: "2px dashed #DBE2FF",
        borderRadius: "10px",
        padding: "32px 32px 4px 32px",
        textAlign: "center",
        bgcolor: dragging ? "action.hover" : "background.paper",
        cursor: "pointer",
        marginBottom: "16px",
        pointerEvents:  Boolean(loanDetails?.tcLoanId) ? "none" : "auto",
        opacity: Boolean(loanDetails?.tcLoanId) ? 0.5 : 1
      }}
    >
      <img src={UploadFileIcon} alt="Upload" style={{ marginBottom: "16px" }} />
      <Typography
        sx={{
          fontFamily: "Poppins",
          fontWeight: 500,
          fontStyle: "Medium",
          fontSize: 14,
          lineHeight: "21px",
          letterSpacing: 0,
          textAlign: "center",
          textTransform: "capitalize",
          color: "#000000",
          marginBottom: "4px",
        }}
      >
        {t("dragAndDrop")}
      </Typography>
      <Typography
        sx={{
          fontFamily: "Poppins",
          fontWeight: 400,
          fontStyle: "Medium",
          fontSize: 12,
          lineHeight: "18px",
          letterSpacing: 0,
          textAlign: "center",
          textTransform: "capitalize",
          color: "#000000",
          marginBottom: "8px",
        }}
      >
        {t("or")}
      </Typography>
      <UploadDocumentButton
        uploadDocument={uploadDocument}
        disabled={Boolean(loanDetails?.tcLoanId)}
        style={{
          color: "#40B4B4",
          textAlign: "center",
          fontFamily: "Poppins",
          fontSize: 12,
          fontStyle: "normal",
          fontWeight: 500,
          lineHeight: "18px",
          textDecorationLine: "underline",
          textDecorationStyle: "solid",
          textDecorationSkipInk: "auto",
          textDecorationThickness: "auto",
          textUnderlineOffset: "auto",
          textUnderlinePosition: "from-font",
          textTransform: "capitalize",
          marginBottom: "8px",
        }}
      />
      <Typography
        sx={{
          fontFamily: "Poppins",
          fontWeight: 400,
          fontStyle: "Regular",
          fontSize: 12,
          lineHeight: "18px",
          letterSpacing: 0,
          textAlign: "center",
          textTransform: "capitalize",
          color: "#666666",
        }}
      >
        {t("uploadFileSubText")}
      </Typography>
    </Box>
  );
}
